<template>
    <div
        :class="`convention-section convention-section-${section.type} ${
            section.className ? section.className : ''
        }`"
        :id="`section-${section.key}`"
    >
        <div v-if="section.type === 'note-di'" class="title-note-di">
            <span>Précisions pour la rubrique Divers</span>
        </div>
        <convention-title
            :title="titleContent"
            :id="section.key"
            :pathIds="ids"
            :type="section.type"
            :cspFilters="cspFilters"
        />
        <convention-body :body="section.body" ref="body" />
        <div class="convention-section-children" ref="children" v-if="section.children">
            <convention-section
                v-for="section in section.children"
                :key="section.key"
                :section="section"
                :pathIds="ids"
            />
        </div>
    </div>
</template>

<script>
import ConventionTitle from "../../ConventionTitle.vue";
import ConventionBody from "../../ConventionBody.vue";

export default {
    name: "ConventionSection",
    components: { ConventionBody, ConventionTitle },
    props: ["section", "pathIds", "cspFilters"],
    computed: {
        titleContent() {
            if (this.section.title.indexOf("|") > -1) {
                return this.section.title.split("|")[1].trim();
            }
            return this.section.title;
        },
        ids() {
            return this.pathIds ? [...this.pathIds, this.section.key] : [this.section.key];
        },
    },
};
</script>

<style lang="sass">
.convention-section-note-di
    border: 2px solid rgb(242, 159, 5)
    width: 70%
    margin-top: 32px
    margin-bottom: 32px
    .title-note-di
        background: rgb(242, 159, 5)
        color: white
        padding: 2px 8px
        width: 100%
        font-style: normal
        margin-bottom: 8px
    .convention-section-title
        padding-left: 8px
    .convention-body
        padding-left: 8px
    .cc-legend
        margin-left: $cc-legend-margin - 10px

.hidden-tag
    display: none

.subtitle
    font-size: 16px
    font-style: italic
    font-weight: 400

.note-di
    border: 2px solid rgb(242, 159, 5)
    width: 70%
    margin-top: 48px
    margin-bottom: 32px
    padding: 8px
    position: relative

    &:before
        content: "Précisions pour la rubrique Divers"
        position: absolute
        top: -26px
        left: 0
        right: 0
        background: rgb(242, 159, 5)
        margin: 0 -2px
        color: white
        padding: 2px 8px
        font-size: 16px
        font-style: normal
    .cc-legend
        margin-left: $cc-legend-margin - 2px
</style>
